import merge from 'deepmerge'

/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable import/no-dynamic-require */

const isWebpack = typeof __webpack_require__ === 'function'
const moduleCache = new Map()

const dynamicRequire = (name) => {
  try {
    const module = isWebpack
      ? // $FlowFixMe: flow can't parse dynamic requires
        require(`__appThemes__/${name}.js`)
      : // $FlowFixMe: flow can't parse dynamic requires
        require(`${process.cwd()}/src/themes/${name}.js`)

    return module.__esModule ? module.default : module
  } catch (err) {
    // ignore
  }

  return {}
}

const requireLocalTheme = (name) => {
  const cachedTheme = moduleCache.get(name)

  if (cachedTheme != null) {
    return cachedTheme
  }

  const localTheme = dynamicRequire(name)
  moduleCache.set(name, localTheme)

  return localTheme
}

const baseTheme = requireLocalTheme('base')

const getLocalTheme = (brand) => {
  if (brand) {
    return merge(baseTheme, requireLocalTheme(brand))
  }

  return baseTheme
}

export default getLocalTheme
